import {
  Home as HomeIcon,
  Sparkles,
  Repeat,
  Truck,
  Briefcase,
  Church,
  Building2,
  ArrowRight,
} from "lucide-react";
import { Link } from "react-router-dom";
import { SERVICES } from "../../data/business";

const iconMap = {
  Home: HomeIcon,
  Sparkles,
  Repeat,
  Truck,
  Briefcase,
  Church,
  Building2,
};

export default function ServicesGrid() {
  return (
    <section id="services" className="section bg-[#F8FAFC]">
      <div className="container-ss">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div className="max-w-2xl">
            <span className="pill mb-3">Our Services</span>
            <h2 className="font-display text-3xl md:text-4xl font-semibold text-slate-900 leading-tight">
              Cleaning services for every space in <span className="text-[#1E3A8A]">Northwest Indiana</span>
            </h2>
            <p className="text-slate-600 mt-3">
              Choose what fits your home or business — every service includes the same care, attention
              and reliability we're known for.
            </p>
          </div>
          <div className="flex flex-wrap gap-3 self-start md:self-end">
            <Link to="/services" className="btn-outline" data-testid="services-view-all">
              View All Services
            </Link>
            <a href="#quote" className="btn-primary" data-testid="services-cta-quote">
              Request a Free Quote <ArrowRight size={16} />
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s) => {
            const Icon = iconMap[s.icon] || HomeIcon;
            return (
              <article
                key={s.slug}
                className="ss-card p-7 flex flex-col"
                data-testid={`service-card-${s.slug}`}
              >
                <div className="h-12 w-12 rounded-2xl bg-[#E0F2FE] text-[#1E3A8A] inline-flex items-center justify-center mb-5">
                  <Icon size={22} />
                </div>
                <h3 className="font-display text-xl font-semibold text-slate-900">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.blurb}</p>
                <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2">
                  <a
                    href="#quote"
                    className="inline-flex items-center gap-2 text-[#1E3A8A] font-semibold text-sm hover:gap-3 transition-all"
                    data-testid={`service-quote-${s.slug}`}
                  >
                    Request Quote <ArrowRight size={14} />
                  </a>
                  {s.page && (
                    <Link to={s.page} className="text-sm text-slate-500 hover:text-[#1E3A8A] underline-offset-4 hover:underline" data-testid={`service-learn-${s.slug}`}>
                      Learn more<span className="sr-only"> about {s.title}</span>
                    </Link>
                  )}
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
